import React from "react";
import { Constants, REPORT_TYPES } from "../../CommonMethhods/Constants";
import LoaderForSearch from "../Common/LoaderForSearch";

// Rows are matched to their checkbox by item.userFriendlyName alone, but the
// API often returns that field blank (or duplicated) across rows, so several
// rows would end up sharing the same value — checking one row then checked
// every other row with the same (often empty) name too. Keying selection off
// "name + row index" instead guarantees a unique key per row regardless of
// what the backend sends for userFriendlyName.
const SELECTION_KEY_SEPARATOR = "|||";

export const getRowSelectionKey = (item, index) =>
  `${item?.userFriendlyName ?? ""}${SELECTION_KEY_SEPARATOR}${index}`;

export const getFileNameFromSelectionKey = (selectionKey) =>
  selectionKey?.split(SELECTION_KEY_SEPARATOR)[0] ?? "";

function ContractListTable(props) {
  let selectAllDeleteSymbolList = props.selectAllDeleteSymbolList;
  let handleSelectionChange = props.handleSelectionChange;
  let userFriendList = props.userFriendList;
  let handleDownloadDocument = props.handleDownloadDocument;
  let dataList = props.data;
  let selectedReportType = props.selectedReportType;
  let clientCode = props.clientCode;

  const reportTypeLabel =
    Object.values(REPORT_TYPES).find(
      (item) => item.value === selectedReportType
    )?.label || "-";

  const downloadPDFClick = (item, id) => {
    handleDownloadDocument(item?.userFriendlyName, id);
  };

  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper contract-list-report">
        <table className="table">
          <thead>
            <tr>
              <th className="rm-maping-item-wrapper" scope="col">
                <div className="cont-select-wrapper">
                  <input
                    type="checkbox"
                    className="contract-checkbox"
                    id="select-all"
                    checked={userFriendList.length >= dataList.length}
                    onChange={selectAllDeleteSymbolList}
                  />
                  <span>Select All</span>
                </div>
              </th>
              <th scope="col" className="text-center">
                Report Type
              </th>
              <th scope="col" className="text-center">
                File Name
              </th>
              <th scope="col" className="text-center">
                {Constants.Client_Code}
              </th>
              <th>Download</th>
            </tr>
          </thead>
          <tbody>
            {dataList.map((item, key) => {
              const selectionKey = getRowSelectionKey(item, key);
              return (
                <tr key={key}>
                  <td className="rm-maping-item-wrapper" key={key}>
                    <input
                      type="checkbox"
                      name={item.userFriendlyName}
                      className="contract-checkbox"
                      value={selectionKey}
                      checked={userFriendList.includes(selectionKey)}
                      onChange={(e) => handleSelectionChange(e)}
                    />
                  </td>
                  <td className="text-center">{reportTypeLabel}</td>
                  <td>{reportTypeLabel === "Contract Note" ? item.userFriendlyName : item.FileName}</td>
                  <td>
                    {item.clientCode || clientCode || "-"}
                  </td>
                  <td>
                    {item.loader ? (
                      <div className="download-loader d-inline-block">
                        <LoaderForSearch />
                      </div>
                    ) : (
                      <button
                        className="icon-file-download"
                        value="pdf"
                        onClick={() => {
                          if (props.isContractNote) {
                            downloadPDFClick(item, key)
                          } else {
                            window.open(item.FilePath, "_blank", "noopener,noreferrer")
                          }
                        }
                        }
                        disabled={!userFriendList.includes(selectionKey)}
                      ></button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}
export default ContractListTable;
